<div class="modals__container">
  <div class="modals__header">
    <img
      mfpLazyImage
      class="modals__close"
      lazySrc="assets/icons/close.svg"
      (click)="close()"
    />
  </div>
  <div class="insurance-reasons">
    <div class="mfp-box-grid__title">{{ 'INSURANCE_REASONS.TITLE' | translate }}</div>
    <div class="mfp-box-grid__flex">
        <ng-container *ngFor="let reason of reasons">
          <div class="insurance-reasons__box mfp-gray-box">
            <img
              mfpLazyImage
              class="mfp-gray-box__image"
              lazySrc="assets/icons/info-gray.svg"
            />
            <p>{{ reason }}</p>
          </div>
        </ng-container>
      </div>
  </div>
</div>
